import React from 'react'
import { Container, BoxCol6, ImagemPrincipal, TextoBanner, LinkBanner, BoxEconomize, BoxEconomizeTexto, BoxAssinaturas, ItemAssinatura, ItemAssinaturaTag, ItemAssinaturaTitulo, ItemAssinaturaPrecoDe, ItemAssinaturaPrecoPor, ItemAssinaturaLinkCartao, ItemAssinaturaLinkAVista, RodapeAssinaturas } from './Styled'
import logoCNU2025 from 'images/pos-cnu-2025/logo-pos-cnu-2025.png'
import bgBannerDesktop from 'images/pos-cnu-2025/bg-banner-principal-desktop.jpg'
import bgBannerMobile from 'images/pos-cnu-2025/bg-banner-principal-mobile.jpg'

export default function BannerPrincipal ({ planos }) {

	return (
		<Container bgDesktop={bgBannerDesktop} bgMobile={bgBannerMobile}>

			{/* Textos Banner */}
			<BoxCol6 className='boxTextos'>
				<ImagemPrincipal src={logoCNU2025} />
				<TextoBanner>Você saiu da inércia, se preparou, evoluiu.<br /> Agora é hora de transformar esse esforço em resultado.</TextoBanner>
				<TextoBanner>Mais de <strong>47 mil vagas</strong> estão previstas nos próximos meses -<br /> e o que você já estudou pode te colocar na frente.</TextoBanner>
				<TextoBanner>Garanta <strong>50% OFF</strong> na Assinatura Premium e acelere sua<br /> aprovação com tudo o que já construiu.</TextoBanner>
				<LinkBanner href={planos[0]['assinaturas'][0]['cartao']['link']}>Assinar</LinkBanner>
			</BoxCol6>

			{/* Aviso Banner */}
			<BoxCol6>
				
				{/* Box Economize */}
				<BoxEconomize>
					<BoxEconomizeTexto><strong>Economize até</strong> R$ 2.441,34</BoxEconomizeTexto>
				</BoxEconomize>

				{/* Lista Assinaturas */}
				<BoxAssinaturas>

					{ planos.map((assinatura, indexAssinaturas) => {
						return assinatura.assinaturas.map((item, index) => (

							<ItemAssinatura key={index}>

								{/* Tag */}
								<ItemAssinaturaTag primeiro={ indexAssinaturas == 0 ? true : false }>{ indexAssinaturas === 0 ? 'A mais vendida' : 'Custo x Benefício' }</ItemAssinaturaTag>

								{/* Título */}
								<ItemAssinaturaTitulo>{item.nome.split(" - ")[0]}</ItemAssinaturaTitulo>

								{/* Preço De */}
								<ItemAssinaturaPrecoDe>{item.cartao.preco_de} por</ItemAssinaturaPrecoDe>

								{/* Preço Por */}
								<ItemAssinaturaPrecoPor>12x <strong>{item.cartao.preco_por.split('12x ')[1]}</strong></ItemAssinaturaPrecoPor>

								{/* Link Cartão */}
								<ItemAssinaturaLinkCartao href={item.cartao.link}>Parcele em 12x sem juros</ItemAssinaturaLinkCartao>

								{/* Link A Vista */}
								<ItemAssinaturaLinkAVista href={item.boleto.link}>Ganhe +10% OFF à vista</ItemAssinaturaLinkAVista>

							</ItemAssinatura>

						))
					})}

				</BoxAssinaturas>

				{/* Rodapé Assinaturas */}
				<RodapeAssinaturas>Oferta por tempo limitado, liberada apenas para alunos<br /> selecionados. Aproveite agora!</RodapeAssinaturas>

			</BoxCol6>

		</Container>
	)
	}
